<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">学生技能证书</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item>
          <el-button type="primary" @click="handleAdd(() => {
            $nextTick(() => {
              $refs.uploadd.setRefFileList('');
            });
          })">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="zsmc" fixed label="证书名称" min-width="160">
        </custom-table-column>
        <custom-table-column prop="zsbh" label="证书编号" width="160">
        </custom-table-column>
        <custom-table-column prop="xzdycs" label="已下载次数" width="160">
        </custom-table-column>
        <custom-table-column prop="jdjg" label="发证机构" width="160">
        </custom-table-column>
        <custom-table-column prop="jddjm" label="证书等级码" width="160" label-class-name="jddjms" :need-color="false"
          :formatter="format_arr">
        </custom-table-column>
        <custom-table-column prop="fzrq" label="发证日期" width="160">
        </custom-table-column>
        <custom-table-column prop="sfzcdzzs" label="是否支持电子证书" width="160" label-class-name="iss" :formatter="format_arr">
        </custom-table-column>
        <custom-table-column label="证书附件" min-width="160">
          <template slot-scope="scope" v-if="scope.row.certificate_file_url">
            <el-link type="primary" v-for="(item, index) in scope.row.certificate_file_url.split(',')" :href="item"
              :key="index" target="_blank">{{ $until.getFileName(item) }}</el-link>
          </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEditNew(scope.row, ['id'], () => handleEditInit(scope.row))" type="text"
              size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>

      <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="786px">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
          <el-form-item label="证书名称" prop="zsmc">
            <el-input v-model="ruleForm.zsmc" placeholder="请输入" style="width:216px;"></el-input>
          </el-form-item>
          <el-form-item label="证书编号" prop="zsbh">
            <el-input v-model="ruleForm.zsbh" placeholder="请输入" style="width:216px;"></el-input>
          </el-form-item>
          <el-form-item label="发证机构" prop="jdjg">
            <el-input v-model="ruleForm.jdjg" placeholder="请输入" style="width:216px;"></el-input>
          </el-form-item>
          <el-form-item label="证书等级码" prop="jddjm">
            <el-select v-model="ruleForm.jddjm" clearable style="width:216px;" placeholder="请选择">
              <el-option v-for="item in $store.state.jddjms" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发证日期" prop="fzrq">
            <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="请选择" v-model="ruleForm.fzrq"
              style="width:216px;"></el-date-picker>
          </el-form-item>
          <el-form-item label="是否支持电子证书" prop="sfzcdzzs">
            <el-select v-model="ruleForm.sfzcdzzs" clearable style="width:216px;" placeholder="请选择">
              <el-option v-for="item in $store.state.iss" :key="item.value" :label="item.label"
                :value="item.value + ''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证书附件" prop="certificate_file_url" style="width:100%">
            <div style="width:552px;">
              <Uploadd ref="uploadd" fileFieldNameIn="certificate_file_url" :isMultiple="true" btnTitle="点击上传图片"
                @setFileList="setFileListMultiple" @delFile="delUpFile"></Uploadd>
            </div>
          </el-form-item>
          <el-form-item style="margin-top:8px;width:100%;text-align:right;">
            <el-button type="primary" v-if="type == 'add'"
              @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
            <el-button type="primary" v-if="type == 'edit'"
              @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
            <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinUpload } from '@/assets/js/mixin/upload';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinUpload, mixinFormatter],
  data() {
    return {
      formInline: {},
      ruleForm: {
        zsmc: '',
        jdjg: '',
        jddjm: "",
        zsbh: "",
        fzrq: '',
        sfzcdzzs: '',
        certificate_file_url: '',
      },
      rules: {
        zsmc: [{ required: true, message: '请输入', trigger: 'blur' }],
        jdjg: [{ required: true, message: '请输入', trigger: 'blur' }],
        jddjm: [{ required: true, message: '请输入', trigger: 'blur' }],
        zsbh: [{ required: true, message: '请输入', trigger: 'blur' }],
        certificate_file_url: [{ required: true, message: '请上传' }],
        sfzcdzzs: [{ required: true, message: '请选择', trigger: 'change' }],
        fzrq: [{ required: true, message: '请选择', trigger: 'change' }],
      },
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/student_skill_certificate/delete/${this.delid}`, 'delete');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    handleEditInit(row) {
      this.handleEditCallBackSetFile({ fileField: "certificate_file_url", row })
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/student_skill_certificate/upload', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer(`api/student_skill_certificate/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/student_skill_certificate/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

/deep/.el-tag {
  cursor: pointer;
}
</style>
